module.exports = __webpack_public_path__ + "img/Volumes.d769ca6 1.718d10c.svg";